import React from "react";
import type { TypeStackProps } from "./StackTypes";
import StackHybrid from "./StackHybrid";

/**
 * Stack component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props, a styled() extension, or responsive/arbitrary-string props).
 */
const Stack = React.forwardRef<HTMLDivElement, TypeStackProps>((props, ref) => (
  <StackHybrid {...props} ref={ref} />
));

Stack.displayName = "Stack";
export default Stack;
